import { useEffect, useRef, useState } from "react";
import { TestTopAddDealerIcon } from "../../components/icons/Icon";
import { CloseIcon } from "../../components/icons/Icon2";
import Button from "../../components/updatedComponents/Dealers/Button";
import styles from "./Marketing2.module.css";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import fetchData from "../../APIsControll/apiControll";
import TextElement from "../../components/updatedComponents/FormComponents/TextElement";
import { formatDateTime, getStatusColor } from "../../Utils/Utils";
import { Spinner } from "react-bootstrap";

const CloseCompleteLead = ({
  mode,
  closeModal,
  managerId,
  lead,
  getLeads,
  flag = "",
}) => {
  const { show } = useToast();
  const inp_con_ref = useRef(null);
  const [notes, setNotes] = useState([{ note: "" }]);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [formType, setFormType] = useState("default");

  const completeLead = async () => {
    const apiData = {
      managerId: managerId,
      leadId: lead.leadId,
      completeReason: reason,
    };
    try {
      const res = await fetchData("leads/completeLead", apiData);

      if (res.status === "success") {
        show(res.msg, "success");
        setLoading(false);
        getLeads();
        closeModal();
      }

      if (res.status === "failed") {
        show(res.msg, "error");
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const closeLead = async () => {
    const apiData = {
      managerId: managerId,
      leadId: lead.leadId,
      closeReason: reason,
    };
    try {
      const res = await fetchData("leads/closeLead", apiData);

      if (res.status === "success") {
        show(res.msg, "success");
        setLoading(false);
        getLeads();
        closeModal();
      }

      if (res.status === "failed") {
        show(res.msg, "error");
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    if (reason.length === 0) {
      show(`Please provide reason to ${formType} the lead!`, "error");
      return;
    }

    if (flag !== "view") {
      if (formType === "close") {
        await closeLead();
      } else {
        await completeLead();
      }
    }
  };

  useEffect(() => {
    if (!lead) return;

    const { notes, closeReason, completeReason } = lead;

    if (Array.isArray(notes) && notes.length > 0) {
      const formattedNotes = notes.map(
        ({ _id, note, createdAt, updatedAt }) => ({
          _id,
          note,
          createdAt,
          updatedAt,
        })
      );
      setNotes(formattedNotes);
    }

    setReason(closeReason || completeReason);
  }, [lead]);

  const saveNote = async () => {
    const trimmedNotes = notes.map((n) => ({
      ...n,
      note: (n?.note || "").trim(),
    }));

    const hasEmpty = trimmedNotes.some((n) => n.note === "");
    const allEmpty = trimmedNotes.every((n) => n.note === "");

    if (allEmpty) {
      show("Please provide at least one note!", "error");
      return;
    }

    if (hasEmpty) {
      show("Please fill out all note fields before submitting!", "error");
      return;
    }

    try {
      setLoading(true);
      const apiData = {
        managerId,
        leadId: lead.leadId,
        notes: trimmedNotes.map(({ _id, note }) =>
          _id ? { _id, note } : { note }
        ),
      };

      const res = await fetchData("leads/saveNote", apiData);
      if (res.status === "success") {
        show(res.msg, "success");
        setLoading(false);
      } else {
        setLoading(false);
        show(res.msg || "Failed to save notes", "error");
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      show("Something went wrong while saving notes.", "error");
    }
  };

  const handleNoteChange = (index, value) => {
    const newNotes = [...notes];
    newNotes[index] = {
      ...newNotes[index],
      note: value,
    };
    setNotes(newNotes);
  };

  const addNote = () => {
    setNotes([...notes, { note: "" }]);
    setTimeout(() => {
      inp_con_ref.current?.scrollBy({
        top: 100,
        behavior: "smooth",
      });
    }, 100);
  };

  const removeNote = (index) => {
    const newNotes = notes.filter((_, i) => i !== index);
    setNotes(newNotes);
  };

  const switchToClose = () => {
    setFormType("close");
    setReason("");
  };

  const switchToComplete = () => {
    setFormType("complete");
    setReason("");
  };

  return (
    <div
      className={styles.close_complete_modal}
      style={{ backgroundColor: mode && "#232529" }}
    >
      <div className={styles.modal_header}>
        <p style={{ color: mode && "#FFFFFF" }}>Lead Management</p>
        <div onClick={closeModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <div
        className={styles.text_con}
        style={{ borderColor: mode && "#646B88" }}
      >
        <div className={styles.text_con_head}>
          <TextElement
            label={"Name:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.name}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
          <TextElement
            label={"Lead ID:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.leadId}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
        </div>
        <div className={styles.text_con_head}>
          <TextElement
            label={"Mobile:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.mobile}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
          <p
            className={styles.status_text}
            style={{ color: getStatusColor(lead.status) }}
          >
            {lead.status}
          </p>
        </div>
        {lead.type === "wholesale" && (
          <TextElement
            label={"Company:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.storeName}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
        )}
        <TextElement
          label={"Address:"}
          labelColor={mode ? "#fff" : "#646B88"}
          value={
            lead.pincode +
            " " +
            lead.city +
            " " +
            (lead.district || "") +
            " " +
            lead.state
          }
          valueColor={mode ? "#fff" : "#646B88"}
          fontSize={"14px"}
          fontWeight={"600"}
        />
        <TextElement
          label={"Assigned to:"}
          labelColor={mode ? "#fff" : "#646B88"}
          value={lead.assignedManager}
          valueColor={mode ? "#fff" : "#646B88"}
          fontSize={"14px"}
          fontWeight={"600"}
        />
      </div>

      <div className={styles.text_area_sec_header}>
        <p className={styles.text_p} style={{ color: mode && "#FFFFFF" }}>
          Notes
        </p>
        {flag !== "view" && (
          <div className={styles.add_btn} onClick={addNote}>
            <TestTopAddDealerIcon color="#4164E3" />
            <span>Add Note</span>
          </div>
        )}
      </div>

      <div className={styles.inp_con} ref={inp_con_ref}>
        {notes.map((note, index) => (
          <div
            key={index}
            className={styles.inp_con_el}
            style={{
              backgroundColor: mode && "#1B1D21",
              borderColor: mode && "#1B1D21",
              color: mode && "#FFFFFF",
            }}
          >
            {flag !== "view" && notes.length !== 1 && (
              <button
                type="button"
                onClick={() => removeNote(index)}
                className={styles.remove_icon}
              >
                ✕
              </button>
            )}

            <textarea
              value={note.note}
              onChange={(e) => handleNoteChange(index, e.target.value)}
              placeholder={`Note ${index + 1}`}
              rows="3"
              readOnly={flag === "view"}
              className={styles.note_text_area}
              style={{ color: mode && "#FFFFFF" }}
            />

            <div className={styles.note_time}>
              <span style={{ color: mode && "#FFFFFF" }}>
                {formatDateTime(
                  note.updatedAt ? note.updatedAt : note.createdAt
                )}
              </span>
            </div>
          </div>
        ))}
      </div>

      {flag !== "view" && (
        <div className={styles.text_area_sec_header}>
          <div className={styles.save_btn} onClick={saveNote}>
            {loading ? (
              <Spinner size="10" />
            ) : (
              <>
                <TestTopAddDealerIcon color="#FFFFFF" />
                <span> Save Note</span>
              </>
            )}
          </div>
        </div>
      )}

      {flag !== "view" && (
        <div className={styles.span_sec}>
          <span
            className={`${styles.span_sec_span} ${
              formType === "complete" ? styles.comp : {}
            }`}
            style={{ color: formType === "complete" ? "#FFFFFF" : "#31974D" }}
            onClick={switchToComplete}
          >
            Mark as Completed
          </span>
          <span
            className={`${styles.span_sec_span} ${
              formType === "close" ? styles.closed : {}
            }`}
            style={{ color: formType === "close" ? "#FFFFFF" : "#F93E3E" }}
            onClick={switchToClose}
          >
            Mark as Closed
          </span>
        </div>
      )}

      {(formType !== "default" ||
        flag === "view" ||
        lead.status === "Closed" ||
        lead.status === "Completed") && (
        <>
          <p className={styles.text_p} style={{ color: mode && "#FFFFFF" }}>
            Reason
          </p>
          <textarea
            className={styles.reason_text_area}
            style={{
              backgroundColor: mode && "#1B1D21",
              borderColor: mode && "#1B1D21",
              color: mode && "#FFFFFF",
            }}
            placeholder={`Enter reason to ${formType} the lead`}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            readOnly={flag === "view"}
            rows="4"
            name=""
            id=""
          ></textarea>

          {flag !== "view" && (
            <div className={styles.bottom_buttons}>
              <div style={{ width: "30%" }}>
                <Button
                  buttonText={"Cancel"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#FFFFFF"}
                  buttonBorder={"none"}
                  buttonClick={() => setFormType("default")}
                />
              </div>
              <div style={{ width: "30%" }}>
                <Button
                  buttonText={formType}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  disabled={loading || flag === "view"}
                  loading={loading}
                  buttonClick={handleSubmit}
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CloseCompleteLead;
